import SetOverSpeedDurationModal from './set-over-speed-duration-modal.vue'
export default SetOverSpeedDurationModal
